// Чистая физика игры: маятник, разбор посадки, профиль здания, золотые блоки.
// Ни Three.js, ни DOM — только математика. Это позволяет гонять юнит-тесты
// в голом node (npm test) без браузера и держать геймплей детерминированным.

/** Скорость маятника растёт с этажами до потолка. P — level.pendulum. */
export function swingSpeed(P, floorCount) {
  return Math.min(P.speedMax, P.speedStart + P.speedPerFloor * floorCount);
}

/**
 * Кинематика маятника в фазе phase (радианы набегают как speed·dt).
 * Возвращает смещение блока от пивота и АНАЛИТИЧЕСКУЮ скорость по x —
 * численная производная по кадрам зависела от FPS и давала снос.
 */
export function swingKinematics(P, phase, speed) {
  const theta = P.amplitude * Math.sin(phase);
  return {
    theta,
    dx: Math.sin(theta) * P.cable,
    dy: -Math.cos(theta) * P.cable,
    // x(t) = sin(A·sin(φ))·L  →  dx/dt = L·cos(θ)·A·cos(φ)·dφ/dt
    vx: P.cable * Math.cos(theta) * P.amplitude * Math.cos(phase) * speed,
  };
}

/** Ярусное сужение (МГУ, Тайбэй, Бурдж): ширина этажа по профилю здания. */
export function profileWidth(level, floorIndex) {
  if (!level.tiers) return level.blockWidth;
  const t = level.tiers;
  const w = level.blockWidth * Math.pow(t.shrink, Math.floor(floorIndex / t.every));
  return Math.max(t.min, w);
}

/**
 * Разбор посадки. Вход — положение блока и верха башни, выход — вердикт:
 *  perfect — |смещение| ≤ perfectThreshold·ширины (магнит к центру);
 *  cut     — перекрытие достаточно, свисающий край срезается;
 *  slip    — перекрытия мало, блок соскальзывает (−1 жизнь).
 */
export function classifyLanding({ bx, blockWidth, topX, topWidth, perfectThreshold, slipThreshold }) {
  const offset = bx - topX;
  const left = Math.max(bx - blockWidth / 2, topX - topWidth / 2);
  const right = Math.min(bx + blockWidth / 2, topX + topWidth / 2);
  const overlap = right - left;

  let type;
  if (Math.abs(offset) <= perfectThreshold * blockWidth) type = 'perfect';
  else if (overlap / blockWidth >= 1 - slipThreshold && overlap >= 0.35) type = 'cut';
  else type = 'slip';

  return { type, offset, overlap, left, right };
}

/** Время свободного падения с высоты gap (из v0=0). */
export function fallTime(gap, gravity) {
  return Math.sqrt(Math.max(0, 2 * gap / gravity));
}

/** Точка приземления по x с учётом начальной скорости и постоянного ветра. */
export function landingX(x0, vx, wind, t) {
  return x0 + vx * t + 0.5 * wind * t * t;
}

/**
 * Золотой блок ×5 — каждый every-й этаж, кроме финального.
 * Детерминирован, а не случаен: сервер обязан уметь посчитать честный
 * потолок очков, с клиентским рандомом античит невозможен.
 */
export function isGoldenFloor(nextFloorNumber, totalFloors, every = 7) {
  return nextFloorNumber % every === 0 && nextFloorNumber < totalFloors;
}
